import styled from 'styled-components'

const GuildFarmStyled = styled.div`
  width: 100%;
`

export default GuildFarmStyled
